export function getAll() {
  return [
    {
      value: 0,
      name: "None",
      text: "---",
    },
    {
      value: 1,
      name: "OverCounts",
      text: "滿數量",
    },
    {
      value: 2,
      name: "OverPrice",
      text: "滿金額",
    },
    {
      value: 3,
      name: "SpecifyItem",
      text: "買A",
    },
    {
      value: 4,
      name: "MatchItems",
      text: "紅配綠",
    },
    {
      value: 5,
      name: "NthItem",
      text: "第N件",
    },
    {
      value: 6,
      name: "GreaterThanCounts",
      text: "N件以上",
    },
  ];
}

export function getByValue(value) {
  return getAll().find((item) => item.value == value);
}
